import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgBlocks} from "~/assets/svg/blocks.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmBlocksIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgBlocks id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
